// extracted by mini-css-extract-plugin
module.exports = {"new":"ProductGalleryView_new_2vBZ2","favorite":"ProductGalleryView_favorite_19PI7","thumb":"ProductGalleryView_thumb_17nJe","image":"ProductGalleryView_image_3mmoZ"};